import React, { Component, Fragment } from "react";
import { NavLink } from "react-router-dom";
import { Formik, FieldArray } from "formik";
import moment from "moment";
import map from "lodash.map";
import filter from "lodash.filter";
import isEmpty from "lodash.isempty";
import isEqual from "lodash.isequal";
import Immutable from "seamless-immutable";
import Form from "react-bootstrap/lib/Form";
import Modal from "react-bootstrap/lib/Modal";
import { Button } from "../../Button";
import { OneFormConsultationFormContainer } from "./OneFormConsultationFormContainer";
import { ProjectCard } from "./ProjectCard";
import {
  ProjectStatus,
  ProjectType,
  ProjectMode,
  ConsultationFormType,
  LegalAge,
} from "../../../utils/enums";
import { Loader } from "../../Loader";
import { ButtonLoader } from "../../ButtonLoader";
import {
  OneFormBudgetVoteValidationSchema,
  OneFormProjectVoteValidationSchema,
} from "../../../validators";
import UserVote from "./UserVote/UserVote";
import { differenceInYears } from "date-fns";
import { Attachment } from "../../Attachment";
import { checkIcon, lockIcon } from "../../../utils/icons";

const AccountCompletionWarning = ({ message }) => {
  if (!message || !message.steps?.length) return null;

  const { instruction, steps } = message;

  return (
    <div
      className="bag d-block m-r4 m-l4"
      style={{
        backgroundColor: "#FDECEA",
        border: "1px solid #F5C6CB",
        borderRadius: "8px",
        padding: "16px 20px",
        color: "#842029",
      }}
    >
      {/* HEADER – FE */}
      {instruction?.text && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "2px",
            marginBottom: "10px",
          }}
        >
          <span aria-hidden="true">
            <i
              className="pe-7s-close"
              style={{ color: "red", fontSize: "35px", fontWeight: "bold" }}
            ></i>
          </span>
          <p style={{ fontWeight: 400, marginTop: "6px" }}>
            {instruction.text}
          </p>
        </div>
      )}

      {/* STEPS – BE */}
      {steps.map((step) => (
        <div key={step.section.key} style={{ marginBottom: "10px" }}>
          <p style={{ marginBottom: "4px", fontWeight: 500 }}>
            {step.action} w sekcji <strong>{step.section.label}</strong>
          </p>

          {step.items?.length > 0 && (
            <ol style={{ marginLeft: "20px", marginBottom: 0 }}>
              {step.items.map((item) => (
                <li key={item.key}>{item.label}</li>
              ))}
            </ol>
          )}
        </div>
      ))}

      {/* CTA – FE */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "end",
          gap: "10px",
          marginTop: "14px",
          marginLeft: "auto",
        }}
      >
        <NavLink
          to="/konto"
          title="Przejdź do ustawień konta"
          style={{
            padding: "8px 14px",
            backgroundColor: "#D32F2F",
            color: "#fff",
            borderRadius: "6px",
            fontWeight: 600,
            textDecoration: "none",
          }}
        >
          Ustawienia konta
        </NavLink>
      </div>
    </div>
  );
};

const NotLoggedUserMessage = () => {
  return (
    <div
      className="bag d-block m-r4 m-l4"
      style={{
        backgroundColor: "#FDECEA",
        border: "1px solid #F5C6CB",
        borderRadius: "8px",
        padding: "16px 20px",
        color: "#842029",
      }}
      role="alert"
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "8px",
          fontWeight: 700,
        }}
      >
        <span aria-hidden="true">
          <i style={{ fontWeight: "bolder" }} className={lockIcon}></i>
        </span>
        <span>Wymagane logowanie</span>
      </div>

      <p style={{ marginBottom: "10px", fontWeight: 400 }}>
        Głosowanie jest dostępne wyłącznie dla zalogowanych użytkowników.
      </p>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        {/* <NavLink
          to="#"
          title="Przejdź do logowania"
          style={{
            padding: "8px 14px",
            backgroundColor: "#D32F2F",
            color: "#fff",
            borderRadius: "6px",
            fontWeight: 600,
            textDecoration: "none",
            transition: "background-color 0.2s ease",
          }}
          onClick={() => userManager.signinRedirect()}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#B71C1C")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "#D32F2F")
          }
        >
          Zaloguj się
        </NavLink> */}
      </div>
    </div>
  );
};

const AccountVotedMessage = () => {
  return (
    <div
      className="bag d-block m-r4 m-l4"
      style={{
        backgroundColor: "#E6F4EA",
        border: "1px solid #B7E1C1",
        borderRadius: "8px",
        padding: "16px 20px",
        color: "#1B5E20",
      }}
      role="status"
      aria-live="polite"
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "6px",
          fontWeight: 700,
        }}
      >
        <span aria-hidden="true">
          <i
            style={{ fontWeight: "bolder", marginTop: "8px", fontSize: "18px" }}
            className={checkIcon}
          ></i>
        </span>
        <span>Głos został oddany</span>
      </div>

      <p style={{ marginBottom: 0, fontWeight: 400 }}>
        Dziękujemy! Twój głos w tym głosowaniu został już zapisany.
      </p>
    </div>
  );
};

export class OneFormProjectCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opened: {
        act: true,
        survey: false,
        probe: false,
      },
      userData: null,
      agreementAccepted: props.agreementAccepted || false,
      authorizeCodeGenerated: props.authorizeCodeGenerated || false,
      ...this.calculateUserVote(),
    };
    this.projectCard = null;

    this.onChangeAgreementAccepted = (e) => {
      this.setState({
        agreementAccepted: e.target.checked,
      });
    };

    this.scrollToAgreement = this.scrollToAgreement.bind(this);

    this.toggleOpen = (e, name) => {
      e.preventDefault();
      this.setState({
        opened: Immutable.merge(this.state.opened, {
          [name]: !this.state.opened[name],
        }),
      });
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.agreementAccepted !== this.props.agreementAccepted) {
      this.setState({
        agreementAccepted: this.props.agreementAccepted,
      });
    }
    if (
      prevProps.authorizeCodeGenerated !== this.props.authorizeCodeGenerated
    ) {
      this.setState({
        authorizeCodeGenerated: this.props.authorizeCodeGenerated,
      });
    }
    if (!isEqual(prevProps.consultationForms, this.props.consultationForms)) {
      this.setState({
        ...this.calculateUserVote(),
      });
    }
  }

  canSetProjectOpinion() {
    return (
      (this.props.mode === ProjectMode.Open ||
        (this.props.mode === ProjectMode.Close && this.props.isAuth) ||
        (this.props.mode === ProjectMode.Citizen &&
          this.props.isAuth &&
          this.props.loggedOfficeId &&
          this.props.officeId === this.props.loggedOfficeId)) &&
      [ProjectStatus.Active].includes(this.props.status) &&
      [ProjectType.Consultation].includes(this.props.type)
    );
  }

  calculateUserVote() {
    if (
      isEmpty(
        filter(
          this.props.consultationForms,
          (form) => form.type !== ConsultationFormType.Comment
        )
      )
    ) {
      return {
        availableVoteForms: 0,
        voteForms: 0,
      };
    }

    return {
      availableVoteForms:
        filter(
          this.props.consultationForms,
          (form) => form.type !== ConsultationFormType.Comment
        ).length || 0,
      voteForms:
        filter(
          this.props.consultationForms,
          (form) => form.type !== ConsultationFormType.Comment && form.voted
        ).length || 0,
    };
  }

  renderAttachmentsIcon(type) {
    switch (type) {
      case "application/pdf": {
        return (
          <i className="fas fa-file-pdf attachments-list__icon attachments-list__icon--primary-dark" />
        );
      }
      default: {
        return (
          <i className="fas fa-file attachments-list__icon attachments-list__icon--primary-dark" />
        );
      }
    }
  }

  renderAttachments(attachments) {
    return (
      <Fragment>
        <div className="consultations__title margin-top-25 margin-bottom-15">
          Załączniki
        </div>
        <div className="attachments-list">
          {map(attachments, (attachment) => (
            <Attachment
              key={attachment.id}
              {...{
                attachment,
                url: `/api/attachments/${attachment.id}`,
              }}
            >
              {this.renderAttachmentsIcon(attachment.contentType)}
            </Attachment>
          ))}
        </div>
      </Fragment>
    );
  }

  renderResultAttachments(resultAttachments) {
    return (
      <Fragment>
        <div className="consultations__title margin-top-25 margin-bottom-15">
          Opublikowane wyniki
        </div>
        <div className="attachments-list">
          {map(resultAttachments, (attachment) => (
            <Attachment
              {...{
                attachment,
                url: `/api/attachments/${attachment.id}`,
              }}
            >
              {this.renderAttachmentsIcon(attachment.contentType)}
            </Attachment>
          ))}
        </div>
      </Fragment>
    );
  }
  scrollToAgreement() {
    this.projectCard.scrollToAgreement();
  }

  addDefaultAnswers(project) {
    let newConsultationForms = map(
      project.consultationForms,
      (consultationForm) => {
        let newCategories = map(consultationForm.categories, (category) => {
          let newQuestions = map(category.questions, (question) => {
            question.answers = isEmpty(question.answers)
              ? [
                  {
                    id: 0,
                    questionId: question.id,
                    userId: this.props.loggedUserId,
                    categoryId: category.id,
                    answerOptions: [
                      {
                        id: 0,
                        comment: "",
                        openText: 0,
                        openDate: null,
                        questionOptionId: 0,
                        questionMatrixValueId: 0,
                      },
                    ],
                  },
                ]
              : question.answers;

            return question;
          });

          category.questions = newQuestions;
          return category;
        });

        consultationForm.categories = newCategories;
        return consultationForm;
      }
    );

    project.consultationForms = newConsultationForms;
    return project;
  }

  getConsultationFormValidationSchema() {
    return this.props.type === ProjectType.PublicBudget
      ? OneFormBudgetVoteValidationSchema
      : OneFormProjectVoteValidationSchema;
  }

  handleSaveUser = (user) => {
    this.setState({ userData: user });
  };

  handleGenerateNewAuthorizeCode = (e) => {
    const { userData, agreementAccepted } = this.state;
    const { id: projectId, agreementHistory, type } = this.props;

    e.preventDefault();
    if (
      !agreementAccepted &&
      !isEmpty(agreementHistory) &&
      (type === ProjectType.PublicBudget || type === ProjectType.Survey)
    ) {
      this.scrollToAgreement();
    } else {
      this.props.generateNewAuthorizeCode(projectId, userData);
    }
  };

  render() {
    const {
      isAuth,
      notLoggedUser,
      availableVoteNotLogged,
      uniqueEmailWhileVotingNotLoggedUser,
      emailConfirmationWhileVotingNotLoggedUser,
      isProjectLoading,
      isOnlyOneOffice,
      loggedOfficeId,
      loggedDistrictId,
      opinionExecuting,
      voteExecuting,
      addCommentOpinion,
      removeCommentOpinion,
      saveComment,
      addProjectOpinion,
      removeProjectOpinion,
      saveAnswers,
      onCancel,
      systemParameters,
      isAuthorizeCodeGenerating,
      errorMessage,
      checkAdditionalID,
      requireDistrict,
      ...project
    } = this.props;

    const {
      disabled,
      type,
      attachments,
      resultAttachments,
      status,
      mode,
      agreementAccepted,
      agreementHistory,
      streetFeatures,
      districts,
      authorizeCodeGenerated = false,
    } = this.props;

    const { userData } = this.state;
    const {
      availableVoteForms,
      voteForms,
      agreementAccepted: stateAgreementAccepted,
      authorizeCodeGenerated: stateAuthorizeCodeGenerated,
    } = this.state;
    let newProject = Immutable.asMutable(project, { deep: true });
    newProject.userData = userData;
    newProject.uniqueEmailWhileVotingNotLoggedUser =
      newProject.type === ProjectType.PublicBudget
        ? uniqueEmailWhileVotingNotLoggedUser
        : false;
    newProject.emailConfirmationWhileVotingNotLoggedUser =
      newProject.type === ProjectType.PublicBudget
        ? emailConfirmationWhileVotingNotLoggedUser
        : false;
    if (type === ProjectType.PublicBudget) {
      newProject = this.addDefaultAnswers(newProject);
    }
    const consultationFormIds = map(
      newProject.consultationForms,
      (cf) => cf.id
    );
    const isLegalAgeNotLoggedUser = userData
      ? differenceInYears(new Date(), new Date(userData.birthDate)) >= LegalAge
      : false;

    const isVoteButtonEnabled =
      !this.props.disabled &&
      (this.props.onlyForLegalAge
        ? this.props.isLegalAgeUser || isLegalAgeNotLoggedUser
        : true);

    const isExecuting = voteExecuting.some((consultationFormId) =>
      consultationFormIds.includes(consultationFormId)
    );
    const isVoted =
      newProject && newProject.consultationForms
        ? newProject.consultationForms.some((_) => _.voted)
        : false;

    const validationSchema = this.getConsultationFormValidationSchema();

    const isPreviewPage = window.location.pathname.includes("podglad");

    return (
      <Fragment>
        {isProjectLoading && <Loader loading={isProjectLoading} />}

        {!isProjectLoading && (
          <Modal
            show={
              !userData &&
              !isAuth &&
              !this.props.disabled &&
              availableVoteNotLogged
            }
            size="lg"
          >
            <Modal.Header>
              <Modal.Title>Dane użytkownika</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <UserVote
                disabled={this.props.disabled}
                availableStreetFeatures={streetFeatures}
                availableDistricts={districts}
                uniqueEmailWhileVotingNotLoggedUser={
                  uniqueEmailWhileVotingNotLoggedUser
                }
                clauseId={newProject.clauseId}
                clauseText={newProject.clauseText}
                onlyForLegalAge={newProject.onlyForLegalAge}
                saveUser={this.handleSaveUser}
                onCancel={onCancel}
                systemParameters={systemParameters}
                consultationForms={this.props.consultationForms || []}
                requireDistrict={requireDistrict}
              />
            </Modal.Body>
          </Modal>
        )}
        {!isProjectLoading && (
          <Formik
            enableReinitialize={
              stateAgreementAccepted === agreementAccepted &&
              authorizeCodeGenerated === stateAuthorizeCodeGenerated
            }
            initialValues={newProject}
            validationSchema={validationSchema}
            render={({
              values,
              handleChange,
              handleBlur,
              isValid,
              errors,
              setFieldValue,
              isSubmitting,
              setSubmitting,
            }) => {
              return (
                <Form
                  noValidate
                  method="post"
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (
                      !stateAgreementAccepted &&
                      !isEmpty(agreementHistory) &&
                      (type === ProjectType.PublicBudget ||
                        type === ProjectType.Survey)
                    ) {
                      this.scrollToAgreement();
                    } else {
                      setSubmitting(true);
                      const consultationForms = map(
                        values.consultationForms,
                        (cf) => ({
                          ...cf,
                          agreementAccepted: stateAgreementAccepted,
                        })
                      );
                      const { userData } = values || {};

                      saveAnswers(
                        values.id,
                        consultationForms,
                        userData,
                        values.authorizeCode
                      );
                      setSubmitting(false);
                    }
                  }}
                >
                  <div id="content" className="container consultations">
                    <div className="margin-bottom-20">
                      <NavLink
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          this.props.onCancel();
                        }}
                        className="link link--primary-dark"
                        title="Powrót"
                        to="#"
                      >
                        <i
                          className="fa fa-chevron-left link__icon link__icon-left"
                          aria-hidden="true"
                        />
                        <span aria-hidden="true">Powrót</span>
                      </NavLink>
                    </div>
                    <ProjectCard
                      ref={(ref) => (this.projectCard = ref)}
                      {...this.props}
                      canSetProjectOpinion={this.canSetProjectOpinion()}
                      disabled={this.props.disabled}
                      addProjectOpinion={(id, type) =>
                        this.props.addProjectOpinion(id, type)
                      }
                      removeProjectOpinion={(id) =>
                        this.props.removeProjectOpinion(id)
                      }
                      opinionExecuting={this.props.opinionExecuting}
                      onChangeAgreementAccepted={this.onChangeAgreementAccepted}
                      availableVoteForms={availableVoteForms}
                      voteForms={voteForms}
                      agreementAccepted={this.props.agreementAccepted}
                      actualAgreementAccepted={this.state.agreementAccepted}
                      agreementAcceptedRequired={!isEmpty(agreementHistory)}
                      scrollToAgreement={this.scrollToAgreement}
                    />
                    {!isPreviewPage && (
                      <AccountCompletionWarning message={errorMessage} />
                    )}
                    {isPreviewPage && isVoted && <AccountVotedMessage />}
                    {!isPreviewPage && !availableVoteNotLogged && !isAuth && (
                      <NotLoggedUserMessage />
                    )}
                    {!isEmpty(values.consultationForms) && (
                      <div
                        className={`consultation__fields${
                          this.props.type === ProjectType.PublicBudget
                            ? " consultation__fields--no-top-padding"
                            : ""
                        }`}
                      >
                        <FieldArray
                          id="consultationForms"
                          name="consultationForms"
                          render={(_) => (
                            <OneFormConsultationFormContainer
                              disabled={
                                this.props.disabled || !isVoteButtonEnabled
                              }
                              requireDistrict={requireDistrict}
                              loggedUserId={this.props.loggedUserId}
                              projectType={this.props.type}
                              items={values.consultationForms}
                              agreementAccepted={this.state.agreementAccepted}
                              agreementHistory={agreementHistory}
                              voteExecuting={this.props.voteExecuting}
                              isLegalAgeUser={isVoteButtonEnabled}
                              onlyForLegalAge={this.props.onlyForLegalAge}
                              isOnlyOneConsultationForms={
                                this.props.consultationForms.length > 0 &&
                                this.props.consultationForms.length === 1
                              }
                              isAuth={isAuth}
                              availableVoteNotLogged={availableVoteNotLogged}
                              notLoggedUserDistrictId={
                                values.userData !== null
                                  ? values.userData.districtId
                                  : 0
                              }
                              projectStatus={status}
                              mode={mode}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              setFieldValue={setFieldValue}
                              errors={errors}
                              isPreview={this.props.isPreview}
                            />
                          )}
                        />
                      </div>
                    )}
                    {attachments &&
                      attachments.length > 0 &&
                      type === ProjectType.Consultation && (
                        <div className="consultations__item">
                          <div className="consultations__body">
                            <div className="consultations__item">
                              {this.renderAttachments(attachments)}
                            </div>
                          </div>
                        </div>
                      )}
                    {attachments &&
                      attachments.length > 0 &&
                      type !== ProjectType.Consultation &&
                      this.renderAttachments(attachments)}

                    {resultAttachments &&
                      resultAttachments.length > 0 &&
                      type === ProjectType.Consultation && (
                        <div className="consultations__item">
                          <div className="consultations__body">
                            <div className="consultations__item">
                              {this.renderResultAttachments(resultAttachments)}
                            </div>
                          </div>
                        </div>
                      )}
                    {resultAttachments &&
                      resultAttachments.length > 0 &&
                      type !== ProjectType.Consultation &&
                      this.renderResultAttachments(resultAttachments)}

                    <hr />
                    <Fragment>
                      <div
                        className={`consultations__buttons margin-top-20 consultations__buttons--align-end ${
                          !!errors.authorizeCode
                            ? "consultations__buttons--with-error"
                            : ""
                        }`}
                      >
                        <Button
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onCancel(this.props.id);
                          }}
                        >
                          Powrót
                        </Button>

                        {(!emailConfirmationWhileVotingNotLoggedUser ||
                          isAuth ||
                          authorizeCodeGenerated) && (
                          <div className="button-container">
                            <ButtonLoader
                              variant="primary"
                              color="#FFF"
                              type="submit"
                              disabled={
                                !isValid ||
                                isSubmitting ||
                                isVoted ||
                                isExecuting ||
                                !isVoteButtonEnabled ||
                                errorMessage
                              }
                              isExecuting={isExecuting}
                              executingText="Zapisywanie"
                              text={
                                isVoted
                                  ? "Oddano głos - Dziękujemy"
                                  : "Zagłosuj"
                              }
                              tooltip={
                                errorMessage
                                  ? "Nie wszystkie wymagane pola zostały uzupełnione. Uzupełnij pola wskazane w komunikacie."
                                  : isVoted
                                  ? "Oddano głos - Dziękujemy"
                                  : !isValid
                                  ? "Aby oddać głos, przydziel punkty wybranym projektom."
                                  : ""
                              }
                            />
                          </div>
                        )}
                        {isVoteButtonEnabled &&
                          emailConfirmationWhileVotingNotLoggedUser &&
                          !isAuth && (
                            <div className="button-container">
                              <ButtonLoader
                                variant="primary"
                                color="#FFF"
                                type="button"
                                onClick={this.handleGenerateNewAuthorizeCode}
                                disabled={
                                  isVoted ||
                                  isAuthorizeCodeGenerating ||
                                  isExecuting
                                }
                                isExecuting={isAuthorizeCodeGenerating}
                                executingText="Generowanie"
                                text="Generuj kod"
                              />
                            </div>
                          )}
                        {authorizeCodeGenerated && (
                          <Form.Row>
                            <Form.Group style={{ position: "relative" }}>
                              <div className="field field--input">
                                <p
                                  style={{
                                    visibility: "hidden",
                                    width: "0px",
                                    height: "0px",
                                    display: "none",
                                  }}
                                  id="aria-authorizeCode"
                                >
                                  Kod autoryzacji głosowania
                                </p>
                                <Form.Label
                                  htmlFor={`authorizeCode`}
                                  className="field__label"
                                >
                                  Kod autoryzacji głosowania
                                </Form.Label>
                                <Form.Control
                                  disabled={disabled || isVoted}
                                  id={`authorizeCode`}
                                  name={`authorizeCode`}
                                  value={values.authorizeCode}
                                  onChange={(_) =>
                                    setFieldValue(_.target.name, _.target.value)
                                  }
                                  className="field__input"
                                  placeholder="Wpisz kod autoryzacji..."
                                  title=""
                                  isInvalid={!!errors.authorizeCode}
                                  autocomplete="off"
                                  aria-labelledby="aria-postCode"
                                />
                              </div>
                              {!!errors.authorizeCode && (
                                <Form.Control.Feedback
                                  type="invalid"
                                  className="field--invalid"
                                  style={{ position: "absolute" }}
                                >
                                  {errors.authorizeCode}
                                </Form.Control.Feedback>
                              )}
                            </Form.Group>
                          </Form.Row>
                        )}
                      </div>
                    </Fragment>
                  </div>
                </Form>
              );
            }}
          />
        )}
      </Fragment>
    );
  }
}

OneFormProjectCard.defaultProps = {
  externalSystemAddress: "",
  commentCount: 0,
  consultationTitle: "",
  dateFrom: moment().format("YYYY-MM-DD"),
  dateTo: moment().format("YYYY-MM-DD"),
  description: "",
  disabled: false,
  loggedUserId: 0,
  id: 0,
  isAuth: false,
  modeName: "",
  moderatorName: "",
  shortDescription: "",
  statusName: "",
  thematicAreaName: "",
  title: "",
  type: 0,
  agreementHistory: null,
  agreementAccepted: false,
  opinionExecuting: [],
  voteExecuting: [],
  streetFeatures: [],
  districts: [],
  addCommentOpinion: Function.prototype,
  addProjectOpinion: Function.prototype,
  onCancel: Function.prototype,
  removeCommentOpinion: Function.prototype,
  removeProjectOpinion: Function.prototype,
  saveAnswers: Function.prototype,
  saveComment: Function.prototype,
};
